// extracted by mini-css-extract-plugin
module.exports = {"tabBarWrapper":"styles_tabBarWrapper__1ZfRH","tabBarIndicator":"styles_tabBarIndicator__2BScB"};